'use strict';
import React, { PureComponent } from 'react';
import CabeceraRenglonAsiento from './CabeceraRenglonAsiento';
import RegistroRenglonAsiento from './RegistroRenglonAsiento';

class SeccionRenglones extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            ultimoId: 1 
        }
        this.handleCuentaContableChange = this.handleCuentaContableChange.bind(this);
    }

    componentDidMount() {
        const {detallesModeloElegido,renglonesManualesFiltrados, cargarRenglonesManualesFiltradosDelModelo} = this.props;

        // Verifico si existen renglones manuales filtrados de manera que NO se haga el filtrado si ya lo hizo inicialmente y quedó almacenado en el state, para evitar perder los datos cargados en los renglones
        if(!renglonesManualesFiltrados.length){
            let renglonesFiltrados = (detallesModeloElegido)
            .map((renglon, index) => ({ ...renglon, renglonId: this.state.ultimoId + index + 1 }));

        cargarRenglonesManualesFiltradosDelModelo(renglonesFiltrados, null, "propsModalNuevoAsiento")

        this.setState(prevState => ({ ultimoId: prevState.ultimoId + renglonesFiltrados.length}));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.detallesModeloElegido !== this.props.detallesModeloElegido) {
            let renglonesFiltrados = this.props.detallesModeloElegido.map((renglon, index) => ({
                ...renglon, renglonId: this.state.ultimoId + index + 1
            }));
    
            this.props.cargarRenglonesManualesFiltradosDelModelo(renglonesFiltrados, null, "propsModalNuevoAsiento");
    
            this.setState(prevState => ({
                ultimoId: prevState.ultimoId + renglonesFiltrados.length
            }));
        }
    }

    handleAgregarRenglon = () => {
        let nuevoId = this.state.ultimoId + 1
    
        this.props.agregarRenglonManual(nuevoId, "propsModalNuevoAsiento","renglonesAgregadosManualmente")
    
        this.setState({ ultimoId: nuevoId });
    };

    handleEliminarRenglon = (renglonId) => {
        this.props.modificarRenglonManual(renglonId, null, "propsModalNuevoAsiento", "renglonesAgregadosManualmente");
    };


    handleDescripcionChange = (renglonId, value) => {
        let renglonActualizado = { DescripcionRenglon: value }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleInputValorReferencia = (renglonId, value) => {
        let renglonActualizado = {
            ReferenciaRenglon: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleCuentaContableChange = (renglonId, cuentaId, codigoCuentaContable, descripcionCuentaContable) => {
        let renglonActualizado = {
            CuentaContableId: cuentaId,
            CuentaContableCodigo: codigoCuentaContable,
            CuentaContableDescripcion: descripcionCuentaContable
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleImporteChange = (renglonId, value, codigoMoneda, idMoneda, tipoOperacion) => {
        let renglonManualExistente = this.props.renglonesManualesFiltrados.find(renglon => renglon.renglonId === renglonId);
 
        const renglonManualActualizado = {
            ImporteAsiento: value,
            MonedaSalidaCodigo: codigoMoneda,
            ModeloMonedaSalidaId: idMoneda,
            TipoOperacion: tipoOperacion
        }

        renglonManualExistente ?  
        this.props.modificarRenglonManual(renglonId, renglonManualActualizado, "propsModalNuevoAsiento", "renglonesManualesFiltrados") :
        this.props.modificarRenglonManual(renglonId, renglonManualActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleChangeValorReferencia = (renglonId, value) => {
        let renglonActualizado = {
            TipoReferencia: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleMonedaSeleccionadaChange = (renglonId, codigoMoneda, idMoneda,) => {
        let renglonActualizado = {
            MonedaSalidaCodigo: codigoMoneda,
            ModeloMonedaSalidaId: idMoneda,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };

    handleChangeCentroDeCosto = (renglonId, value) => {
        let renglonActualizado = {
            CentroCostoId: value,
        }
        this.props.modificarRenglonManual(renglonId, renglonActualizado, "propsModalNuevoAsiento", "renglonesAgregadosManualmente")
    };   

    render() {
        const {
            agregarRenglonManual,
            modificarRenglonManual,
            buscarCuentasContables,
            centrosCosto,
            cuentasContables,
            inputCuentaContable,
            inputActivo,
            cambiarValorInput,
            cambiarInputActivo,
            detalleRenglonDatosDesplegados,
            detallesModeloElegido,
            registrosManuales = [],
            renglonesManualesFiltrados = [],
            desplegarDatosDetalleRenglonNuevoAsiento,
            comboModeloNuevoAsiento,
            monedasAsiento
        } = this.props;

        let todosLosRegistros = [
            ...renglonesManualesFiltrados,
            ...registrosManuales
        ];

        let totalesPesosDebe = 0;
        let totalesPesosHaber = 0;
        let totalesDolaresDebe = 0;
        let totalesDolaresHaber = 0;

        if (todosLosRegistros) {
            todosLosRegistros.forEach(reg => {
                let { ModeloMonedaSalidaCodigo, MonedaSalidaCodigo, TipoOperacion, ImporteAsiento } = reg;
        
                if (ImporteAsiento) {
                    let importe = parseFloat(ImporteAsiento.replace(',', '.'));
                    if (!isNaN(importe)) {
                        if (ModeloMonedaSalidaCodigo == "PESO" || MonedaSalidaCodigo == "PESO" || ModeloMonedaSalidaCodigo == "1" || MonedaSalidaCodigo == "1") {
                            if (TipoOperacion == 1) {
                                totalesPesosDebe += importe;
                            } else if (TipoOperacion == 2) {
                                totalesPesosHaber += importe;
                            }
                        } else if (ModeloMonedaSalidaCodigo == "DOLAR" || MonedaSalidaCodigo == "DOLAR" || ModeloMonedaSalidaCodigo == "2" || MonedaSalidaCodigo == "2") {
                            if (TipoOperacion == 1) {
                                totalesDolaresDebe += importe;
                            } else if (TipoOperacion == 2) {
                                totalesDolaresHaber += importe;
                            }
                        }
                    }
                }
            });
        }
        
        totalesPesosDebe = totalesPesosDebe.toFixed(2);
        totalesPesosHaber = totalesPesosHaber.toFixed(2);
        totalesDolaresDebe = totalesDolaresDebe.toFixed(2);
        totalesDolaresHaber = totalesDolaresHaber.toFixed(2);

        let mostrarTotalizadorPesos = totalesPesosDebe != 0 || totalesPesosHaber != 0;
        let mostrarTotalizadorDolares = totalesDolaresDebe != 0 || totalesDolaresHaber != 0;
        let ConfirmacionAutomatica = detallesModeloElegido.length === 0 ? false : (detallesModeloElegido[0].ConfirmacionAutomatica ? true : false);
        let totalizadoresComponente = [];

        if (mostrarTotalizadorPesos) {
            totalizadoresComponente.push(
                <RegistroRenglonAsiento
                    key="totalizadorPesos"
                    registro={null}
                    totalDebe={ "$ " + totalesPesosDebe}
                    totalHaber={ "$ " + totalesPesosHaber}
                    esTotalizador={true}
                    tipoMoneda="PESO"
                />
            );
        }
        
        if (mostrarTotalizadorDolares) {
            totalizadoresComponente.push(
                <RegistroRenglonAsiento
                    key="totalizadorDolares"
                    registro={null}
                    totalDebe={"U$S " + totalesDolaresDebe}
                    totalHaber={"U$S " + totalesDolaresHaber}
                    esTotalizador={true}
                    tipoMoneda="DOLAR"
                />
            );
        }

        let estaBalanceado = 
        Math.round(totalesPesosDebe * 100) === Math.round(totalesPesosHaber * 100) &&
        Math.round(totalesDolaresDebe * 100) === Math.round(totalesDolaresHaber * 100);


        let mensaje = 'Asiento balanceado';
        if (!estaBalanceado) {
            let diferencias = [];
         if (totalesPesosDebe !== totalesPesosHaber) {
            let diferenciaPesos = Math.abs(totalesPesosDebe - totalesPesosHaber).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            diferencias.push(`$${diferenciaPesos}`);
            }
         if (totalesDolaresDebe !== totalesDolaresHaber) {
            let diferenciaDolares = Math.abs(totalesDolaresDebe - totalesDolaresHaber).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
         diferencias.push(`u$s${diferenciaDolares}`);
         }
        mensaje = `Asiento desbalanceado: ${diferencias.join(' y ')}`;
        }
        
        return (
            <div className="AsientosContables__modalDetalleAsiento__contenedorSectorGrilla AsientosContables--overflowHidden">
                <div className="seccionRenglonesModelo__contenedorInfoGeneralBotones__cantidadRenglones AsientosContables__modalDetalleAsiento__cantidadRenglones AsientosContables--floatNone">
                    Cantidad de renglones: {todosLosRegistros.length}
                </div>

                <div className="AsientosContables__modalDetalleAsiento__contenedorBotonAgregarRenglonExcel AsientosContables--overflowHidden">
                    <div className="AsientosContables--floatLeft">
                        <button className="seccionRenglonesModelo__botonAgregar AsientosContables__modalDetalleAsiento__botonAgregarRenglon" onClick={() => comboModeloNuevoAsiento != "0" ? this.handleAgregarRenglon() : null}>
                            Agregar renglón
                        </button>
                    </div>
                </div>

                <div className="AsientosContables__modalDetalleAsiento__Grilla">
                    <CabeceraRenglonAsiento />

                    {todosLosRegistros.map((reg, index) => (
                        <RegistroRenglonAsiento
                            index={index}
                            key={reg.renglonId}
                            registro={reg}
                            centrosCosto={centrosCosto}
                            cuentasContables={cuentasContables}
                            inputCuentaContable={inputCuentaContable}
                            inputActivo={inputActivo}
                            buscarCuentasContables={buscarCuentasContables}
                            cambiarValorInput={cambiarValorInput}
                            cambiarInputActivo={cambiarInputActivo}
                            detalleRenglonDatosDesplegados={detalleRenglonDatosDesplegados}
                            desplegarDatosDetalleRenglonNuevoAsiento={desplegarDatosDetalleRenglonNuevoAsiento}
                            monedasAsiento={monedasAsiento}
                            borrarRenglon={() => this.handleEliminarRenglon}
                            actualizarDescripcionRenglon={this.handleDescripcionChange}
                            OnInputValorReferencia={this.handleInputValorReferencia}
                            actualizarImporteRenglon={this.handleImporteChange}
                            onCuentaContableChange={this.handleCuentaContableChange}
                            onValorReferenciaChange={this.handleChangeValorReferencia}
                            onCentroDeCostoChange={this.handleChangeCentroDeCosto}
                            onImporteChange={this.handleImporteChange}
                            OnMonedaSeleccionadaChange={this.handleMonedaSeleccionadaChange}
                            />
                    ))}

                    {totalizadoresComponente}
                    
                </div>

                    <div className="AsientosContables--overflowHidden">
                    <div className={estaBalanceado ? "icono-tildeVerde" : "icono-cruzRoja"}></div>
                    <div className="AsientosContables__modalDetalleAsiento__registroBalanceado AsientosContables--floatLeft">
                    {mensaje} 
                    </div>
                     {ConfirmacionAutomatica && (
                            <div className=" AsientosContables--floatLeft"> - Se confirmará automáticamente</div>
                        )}
                    </div>
            </div>
        );
    }
}

export default SeccionRenglones;